import Stop from '@/models/Stop'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1
    },
    fetchingList: false,
    stopDetails: {
      name: '',
      place_ids: [],
      places_address: '',
      google_places_id: null
    }
  },

  mutations: {
    setFetchingList(state, status) {
      state.fetchingList = status
    },

    setStopList(state, stops) {
      each(stops, stop => {
        const exist = find(state.list, { id: stop.id })
        if (!exist) {
          state.list.push(new Stop(stop))
        }
      })
    },

    clearStopList(state) {
      state.list = []
    },

    setStopListMeta(state, meta) {
      state.listMeta = meta
    },

    setStopDetails(state, stop) {
      if (stop instanceof Stop) {
        state.stopDetails = stop
      } else {
        state.stopDetails = new Stop(stop)
      }
    },

    clearStopDetails(state) {
      state.stopDetails = {
        name: '',
        place_ids: [],
        places_address: '',
        google_places_id: null
      }
    }
  },

  actions: {
    clearStopDetails({ commit }) {
      commit('clearStopDetails')
    },

    async createStop({ commit }, formData) {
      const { data } = await Api.post(`admin/stops`, formData, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      commit('setStopDetails', data.data)
    },

    async updateStop({ commit }, formData) {
      const { data } = await Api.put(`admin/stops/${formData.id}`, formData)
      commit('setStopDetails', data.data)
    },

    async deleteStop({ commit }, stopId) {
      const { data } = await Api.delete(`admin/stops/${stopId}`)
      commit('setStopDetails', data.data)
    },

    async getStops({ commit }, params) {
      const query = Stop.page(params.page || 1)

      if (params.search) {
        query.where('search', params.search)
      }

      const res = await query.params({ limit: 20 }).get()

      commit('setStopList', res.data)
      commit('setStopListMeta', res.meta)
    },

    async getStopDetails({ commit }, id) {
      const { data } = await Api.get(`admin/stops/${id}`)
      commit('setStopDetails', data.data)
    },

    async getAllStops({ commit }) {
      commit('setFetchingList', true)
      const { data } = await Api.get(`admin/stops?all=true`).finally(() =>
        commit('setFetchingList', false)
      )
      commit('setStopList', data.data)
    }
  }
}
